/* eslint-disable unicorn/no-null */
import { isPlainObject } from 'es-toolkit';
import { isObject } from 'es-toolkit/compat';

export const ARCHIVE_ERROR_NOTIFICATION_DURATION = 6000;

export const uploadArchiveToSignedUrl = async (
    archive: File,
    uploadUrl: string,
    method: string,
    headers: Record<string, string>
): Promise<void> => {
    const response = await fetch(uploadUrl, {
        method,
        headers,
        body: archive
    });

    if (!response.ok) {
        throw new Error(
            `Upload to storage failed (${response.status} ${response.statusText})`
        );
    }
};

export const extractServerErrorMessage = (error: unknown): string | null => {
    if (
        !isObject(error) ||
        !('response' in error) ||
        !isPlainObject(error.response)
    ) {
        return null;
    }

    const { data } = error.response;
    if (typeof data === 'string' && data.length > 0) {
        return data;
    }
    if (!isPlainObject(data)) {
        return null;
    }

    const { detail } = data;
    if (typeof detail === 'string' && detail.length > 0) {
        return detail;
    }
    if (Array.isArray(detail)) {
        const messages = detail
            .map((entry: unknown) => {
                if (!isPlainObject(entry)) {
                    return null;
                }
                return typeof entry.msg === 'string' && entry.msg.length > 0
                    ? entry.msg
                    : null;
            })
            .filter((message): message is string => message !== null);

        if (messages.length > 0) {
            return messages.join('; ');
        }
    }

    if (typeof data.reason === 'string' && data.reason.length > 0) {
        return data.reason;
    }
    if (typeof data.message === 'string' && data.message.length > 0) {
        return data.message;
    }

    return null;
};

export const isRequestTimeout = (error: unknown): boolean =>
    isObject(error) && 'code' in error && error.code === 'ECONNABORTED';
